/**
 * Brand Logo Injector
 * Dynamically switches header logo based on current domain to bypass Shopify CDN caching issues.
 * Runs on every page load to ensure correct brand logo is displayed.
 *
 * LOCAL DEV TESTING:
 * - Add ?__test_brand=als to URL to force Als Bootery logo (e.g., http://localhost:3000/?__test_brand=als)
 * - Or in browser console: localStorage.setItem('__test_brand', 'als'); location.reload();
 * - Reset with: localStorage.removeItem('__test_brand');
 */

(function () {
  "use strict";

  const DEBUG = true; // Set to false to disable console logging in production

  // Detect current brand based on domain or test override
  function detectBrand() {
    // Check for test override via query parameter
    const params = new URLSearchParams(window.location.search);
    const testBrand =
      params.get("__test_brand") || localStorage.getItem("__test_brand");

    if (testBrand && (testBrand === "als" || testBrand === "bighorn")) {
      if (DEBUG) {
        console.log(
          "[Brand Logo Injector] Using test brand override:",
          testBrand,
        );
      }
      return testBrand;
    }

    // Detect based on actual hostname
    const host = window.location.hostname.toLowerCase();
    const detected = host.includes("alsbootery") ? "als" : "bighorn";

    if (DEBUG) {
      console.log(
        "[Brand Logo Injector] Detected brand from hostname:",
        detected,
        `(${host})`,
      );
    }

    return detected;
  }

  // Hide all logos and show the correct one
  function injectBrandLogo() {
    const currentBrand = detectBrand();
    const logoWrapper = document.querySelector(".header__heading-logo-wrapper");

    if (!logoWrapper) {
      if (DEBUG) {
        console.log("[Brand Logo Injector] Logo wrapper not found");
      }
      return;
    }

    const bigHornLogo = logoWrapper.querySelector('[data-brand="bighorn"]');
    const alsLogo = logoWrapper.querySelector('[data-brand="als"]');

    // Hide both
    if (bigHornLogo) bigHornLogo.style.display = "none";
    if (alsLogo) alsLogo.style.display = "none";

    // Show the correct one
    if (currentBrand === "als" && alsLogo) {
      alsLogo.style.display = "";
      if (DEBUG) {
        console.log("[Brand Logo Injector] ✓ Showing Als Bootery logo");
      }
    } else if (currentBrand === "bighorn" && bigHornLogo) {
      bigHornLogo.style.display = "";
      if (DEBUG) {
        console.log("[Brand Logo Injector] ✓ Showing BigHorn Boot logo");
      }
    }

    // Add data attribute for CSS/debugging
    logoWrapper.setAttribute("data-current-brand", currentBrand);

    // Add visual indicator in test mode
    const isTestMode =
      new URLSearchParams(window.location.search).has("__test_brand") ||
      localStorage.getItem("__test_brand");
    if (isTestMode) {
      logoWrapper.setAttribute("data-test-mode", "true");
      if (DEBUG) {
        console.log(
          "[Brand Logo Injector] 🧪 TEST MODE ACTIVE - using override brand",
        );
      }
    }
  }

  // Run on DOMContentLoaded for early execution
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectBrandLogo);
  } else {
    injectBrandLogo();
  }

  // Also run on page show to handle back/forward navigation and cache restores
  window.addEventListener("pageshow", injectBrandLogo);

  // Expose for manual triggering and testing
  window.injectBrandLogo = injectBrandLogo;
  window.detectBrand = detectBrand;

  // Provide test utilities in console
  window.__brandLogoTester = {
    setTestBrand: function (brand) {
      if (brand === "als" || brand === "bighorn") {
        localStorage.setItem("__test_brand", brand);
        location.reload();
      } else {
        console.error(
          "[Brand Logo Injector] Invalid brand. Use 'als' or 'bighorn'",
        );
      }
    },
    clearTestBrand: function () {
      localStorage.removeItem("__test_brand");
      location.reload();
    },
    getCurrentBrand: function () {
      return detectBrand();
    },
    info: function () {
      console.log(
        "%c[Brand Logo Injector Test Mode]",
        "color: #0066ff; font-weight: bold;",
        "\nUsage:\n" +
          "  __brandLogoTester.setTestBrand('als')      // Force Als Bootery logo\n" +
          "  __brandLogoTester.setTestBrand('bighorn')  // Force BigHorn logo\n" +
          "  __brandLogoTester.clearTestBrand()         // Clear override\n" +
          "  __brandLogoTester.getCurrentBrand()        // Get current brand\n\n" +
          "Or use URL parameter: ?__test_brand=als\n",
      );
    },
  };

  if (DEBUG) {
    console.log(
      "%c[Brand Logo Injector]",
      "color: #00aa00; font-weight: bold;",
      "Initialized. Current brand:",
      detectBrand(),
    );
    console.log("  Type __brandLogoTester.info() for testing help");
  }
})();
